export enum BillingFrequency {
    Annually = 12
}

export interface BillingFrequencyOption {
    value: number;
    textKey: string;
}

export const BillingFrequencyOptions: BillingFrequencyOption[] = [
    {
        value: BillingFrequency.Annually,
        textKey: 'MembershipProducts_BillingFrequencyAnnually'
    }
];